import React from 'react';
import PropTypes from 'prop-types';

import Label from 'core/components/label/label';
import DownloadButton from 'tools/helpers/generate-task-ui/components/download-button';
import { ARTIFACT_OUTPUTS } from './helpers';
import useStyles from './run-artifacts.styles';

/**
 * The snapshot CSVs for one run — the only place the per-record ids (which policies, which offers,
 * which member/policy mismatches) are visible; every other surface shows counts.
 *
 * Uses DownloadButton with the run's previewTaskRunId so each click mints a fresh URL via
 * `toolsRefreshTaskOutputUrl`. The links handed out at preview time expire in hours, so a raw href
 * would be dead by the time anyone approves.
 */
const RunArtifacts = ({ previewTaskRunId }) => {
  const classes = useStyles();

  if (!previewTaskRunId) {
    return <Label type="infoLabel">No snapshot recorded for this run.</Label>;
  }

  return (
    <div className={classes.list}>
      {ARTIFACT_OUTPUTS.map(({ output, label }) => (
        // The description IS the download link — no separate "Download file" button per row.
        <DownloadButton key={output} taskRunId={previewTaskRunId} output={output} label={label} />
      ))}
    </div>
  );
};

RunArtifacts.propTypes = {
  previewTaskRunId: PropTypes.string
};

RunArtifacts.defaultProps = {
  previewTaskRunId: null
};

export default RunArtifacts;
